// extracted by mini-css-extract-plugin
module.exports = {"Container":"Email_Container__2Gb71","Icon":"Email_Icon__G9wjH"};